import PropTypes from 'prop-types';

import RichText, { fragment } from '../../Core/RichText';
import Link from '../../Core/Link';
import Disclaimer from '../Disclaimer';

import {
  Section,
  Grid,
  Intro,
  Cards,
  Card,
  Content,
  Footer,
  SectionDisclaimerWrapper,
} from './styles';

const LongFeatureCards = ({ data }) => {
  if (!data) return null;

  const {
    anchorName,
    backgroundColor,
    component,
    contentAlignment,
    sectionContainerHeading,
    sectionSubheading,
    elements,
    ctas,
    legalCopy,
    column,
    className,
  } = data;

  return (
    <Section
      id={anchorName}
      backgroundColor={backgroundColor}
      contentAlignment={contentAlignment}
      className={`${component} ${className} `}
      column
    >
      <Grid bgColor={backgroundColor}>
        {(sectionContainerHeading || sectionSubheading) && (
          <Intro>
            {sectionContainerHeading && (
              <RichText document={sectionContainerHeading} />
            )}
            {sectionSubheading && <RichText document={sectionSubheading} />}
          </Intro>
        )}
        <Cards column={!!column}>
          {elements.map(({ id, heading, bodyCopy, imageDam }) => {
            return (
              <Card key={id} icon={imageDam?.asset.localImage?.publicURL}>
                {(heading || bodyCopy) && (
                  <Content>
                    <RichText document={heading} />
                    {bodyCopy && <RichText document={bodyCopy} />}
                  </Content>
                )}
              </Card>
            );
          })}
        </Cards>
        <Footer>
          {ctas &&
            ctas.map(cta => {
              if (cta.hideFrench === true) return null;
              return (
                <Link key={cta.id} data={cta}>
                  <RichText document={cta.label} options={fragment} />
                </Link>
              );
            })}
        </Footer>
        {legalCopy && (
          <SectionDisclaimerWrapper>
            <Disclaimer data={legalCopy} color="black" />
          </SectionDisclaimerWrapper>
        )}
      </Grid>
    </Section>
  );
};

LongFeatureCards.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default LongFeatureCards;
